module.exports = __webpack_public_path__ + "0fdb5c77d8ae780414f9ce998014b7c1.svg";